// Ukryte, nie usunięte. Zmień na true, żeby przywrócić funkcje młodocianych / egzaminy.
export const FEATURES = { youth: false, exams: false };
